import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Липсва алтернативен текст за това изображение',
    noAnswers: 'Няма опция за отговор. Кликнете „Напред“, за да продължите.',
    placeholder: 'Пояснете...',
    pleaseSelect: 'Изберете...',
    rotateLandscape: 'Моля, изключете заключването на ориентацията на телефона си и го завъртете в пейзажен режим.',
    rotatePortrait: 'Завъртете телефона си от пейзажен в портретен режим.',
    ir: {
      selectWebCam:
        'Изберете уебкамера (ако е налична) или кликнете върху „Преглед“, за да качите от Вашето устройство',
      uploadOnly: "Кликнете върху 'Преглед', за да качите от Вашето устройство",
      noWebCam: 'Не е открита уебкамера',
      accessCamUpload: 'ДОСТЪП ДО КАМЕРА/КАЧВЕНЕ',
      browse: 'ПРЕГЛЕД',
      uploadPhoto: 'Качи снимка',
      camera: 'Уебкамера',
      instead: 'вместо',
      capture: 'ЗАСНЕМАНЕ',
      somethingWrong: 'За съжаление нещо се обърка. Опитайте отново по-късно',
      couldntRead: 'За съжаление не успяхме да прочетем кода!',
      couldntProcess: 'За съжаление не успяхме да обработим изображението Ви!',
      inValidCode: 'Изпратете валидния код',
      moveOn: 'Опитайте отново или изпратете снимката си и продължете напред',
      tryAgain: 'Опитайте отново',
      dataReceived: 'Данните са получени!',
      enterManually: 'Опитайте отново или въведете данните ръчно по-долу',
      positionQR:
        'Поставете QR кода пред камерата си така, че да се побере в червената рамка, или го качете от компютъра си.',
      positionQRMobile: 'Поставете QR кода пред камерата си или го качете от Вашето устройство.',
      analyzing: 'Анализиране на изображението, моля, изчакайте',
      submit: 'ИЗПРАЩАНЕ',
      startOver: 'Започни отначало',
      allDone: 'Готово!',
      cantAnalyze:
        'Внимание – не можахме да разпознаем това изображение. Опитайте да го изпратите повторно или изберете по-общ формат на изображението (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Съжаляваме – не поддържаме този файлов формат. Качете поддържан тип изображение (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Не е открита уебкамера',
      uploadVideo: 'Качете видео',
      skip: 'Пропусни?',
      accessCamUpload: 'ДОСТЪП ДО КАМЕРА/КАЧВЕНЕ',
      browse: 'ПРЕГЛЕД',
      instead: 'вместо',
      or: 'или',
      stopRecording: 'Спрете записа',
      willBeStopped: 'Записът ще спре след <b>5 минути</b>',
      stopOnDone: 'Спрете да записвате, когато сте готови!',
      record: 'ЗАПИС',
      somethingWrong: 'За съжаление нещо се обърка. Опитайте отново по-късно.',
      dataReceived: 'Данните са получени!',
      microphone: 'Микрофон',
      camera: 'Уебкамера',
      selectMicrophone: 'Изберете микрофон',
      selectCam: 'Изберете уебкамера',
      submit: 'ИЗПРАЩАНЕ',
      upload: 'КАЧЕТЕ',
      playback: 'Възпроизвеждане',
      stopPlayback: 'СПИРАНЕ НА ВЪЗПРОИЗВЕЖДАНЕТО',
      startOver: 'ЗАПОЧНИ ОТНАЧАЛО',
      allDone: 'Готово!',
      alternativeRecordSpan: 'Качете видеоклип от Вашето компютърно устройство.<br/>Като алтернатива можете &nbsp;',
      alrenativeRecordHref: 'да запишете видеоклипа с уебкамера.',
      cantAnalyze:
        'Внимание – не можахме да разпознаем това видео. Опитайте да го изпратите повторно или изберете по-общ видеоформат (MP4, M4V, WEBPM)',
      wrongFormat:
        'Съжаляваме – не поддържаме този файлов формат. Качете поддържан тип видео (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'ИЗБОР',
      pleaseChoose: 'Изберете',
      this: 'ТОВА',
      one: ' eднн',
      myChoice: 'Моят ИЗБОР'
    },
    hm: {
      addComment: 'Добавете коментар по-долу',
      commentMandatoryPlaceHolder: 'Добавете задължителен коментар... ',
      commentOptionalPlaceHolder: 'Добавете коментар по избор... ',
      dragPin: 'Плъзнете за препозициониране (дълго кликване/натискане за прецизно закачане).',
      removePin: 'Плъзнете извън изображението за изтриване.  ',
      editComment: 'Кликнете/натиснете върху маркер за редактиране на коментар.',
      addPin: 'Плъзнете маркера от панела по-долу и го пуснете на избрано от Вас място върху изображението.',
      addPins: 'Плъзнете маркерите от панела по-долу и ги пуснете на избрано от Вас място върху изображението. ',
      leavePins: (minPoints, maxPoints) =>
        `Оставете поне ${minPoints}, но не повече от ${maxPoints} маркера от всеки вид.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Оставете поне ${minPoints}, но не повече от ${maxPoints} маркера от който и да е вид. `,
      leavePinsPerPage: (minPoints, maxPoints) => `Оставете поне ${minPoints}, но не повече от ${maxPoints} маркера.`,
      leavePinsWithOff: maxPoints =>
        `Оставете не повече от ${maxPoints} маркера от всеки вид или кликнете върху „Напред“ за пропускане.`,
      leavePinsWithOffAny: maxPoints =>
        `Оставете не повече от ${maxPoints} маркера от който и да е вид или кликнете върху „Напред“ за пропускане.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Оставете не повече от ${maxPoints} маркера или кликнете върху „Напред“ за пропускане.`,
      leavePinWithOff: `Оставете не повече от 1 маркер от всеки вид или кликнете върху „Напред“ за пропускане.`,
      leavePinWithOffAny: `Оставете не повече от 1 маркер от който и да е вид или кликнете върху „Напред“ за пропускане.`,
      leavePinPerPageWithOff: 'Оставете не повече от 1 маркер или кликнете върху „Напред“ за пропускане.',
      leaveExactlyPin: `Оставете 1 маркер от всеки вид.`,
      leaveExactlyPinAny: `Оставете 1 маркер от който и да е вид.`,
      leaveExactlyPinPerPage: 'Оставете 1 маркер. ',
      leaveExactlyPins: maxPoints => `Оставете ${maxPoints} маркера от всеки вид.`,
      leaveExactlyPinsAny: maxPoints => `Оставете ${maxPoints} маркера от който и да е вид.`,
      leaveExactlyPinsPerPage: maxPoints => `Оставете ${maxPoints} маркера.`,
      leaveComment: 'Въведете под изображението, за да оставите коментар.',
      noAnswers: 'Няма опция за отговор. Кликнете „Напред“, за да продължите.',
      outOfPins: 'маркерите Ви се изчерпаха',
      pinsBehavior: 'Когато се движите по изображението, ще видите области, които са маркирани с топче на маркерите.',
      clusters: 'Ще можете да поставяте маркерите само в тези очертани области.',
      contentAware: 'Можете да поставяте маркерите във или извън маркираните области.'
    },
    mp: {
      expand_note:
        'Моля, задръжте стрелката върху изображението(ята) или кликнете върху него(тях), за да го(ги) разтворите.',
      rb_note: rows => `Изберете само 1 отговор за всеки елемент${rows ? ' по-долу' : ''}:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Изберете ${min !== 1 ? '' : 'само'} ${min} отговор${min !== 1 ? 'а' : ''} за всеки елемент${
            rows ? ' по-долу' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Моля, изберете най-малко ${min} отговор${
            min !== 1 ? 'а' : ''
          }, но не повече от ${max} отговора на въпрос:`
        } else if (5000 === max && min > 0) {
          return `Моля, изберете поне ${min} отговор${min !== 1 ? 'а' : ''} на въпрос:`
        } else if (0 === min && max < 5000) {
          return `Моля, изберете не повече от ${max} отговор${max !== 1 ? 'а' : ''} на въпрос:`
        } else {
          return 'Маркирайте всички приложими:'
        }
      }
    },
    sh: {
      note: 'Кликнете върху продукт, за да го увеличите и добавите към Вашата виртуална количка, ако бихте го купили в магазина',
      amazonNote: 'Кликнете върху продукт, за да го увеличите и добавите към Вашата виртуална количка.',
      fullCart: 'Количката Ви е пълна!',
      qty: 'КОЛИЧЕСТВО',
      addToCart: 'ДОБАВИ В КОЛИЧКАТА',
      deleteFromCart: 'ИЗТРИЙ',
      each: 'всеки',
      items: 'ел',
      emptyCard: 'Количката Ви е празна',
      total: 'Количка',
      clearCart: 'Изчистване на количката',
      backToStore: 'Обратно в магазина',
      na: 'Нито едно от посочените',
      next: 'НАПРЕД',
      maxCartCountError: max => `Моля, не добавяйте повече от ${max} продукта във Вашата количка. `,
      scrollError: `Моля, превъртете изцяло наляво и надясно, за да продължите анкетата. `,
      maxSpentError: max => `Моля, не харчете повече от ${max}. `,
      maxProductCountError: max => `Моля, не добавяйте във Вашата количка повече от ${max} за всеки продукт.`
    },
    rb: {
      note: 'Изберете само 1 елемент:'
    },
    vo: {
      note: 'Изгледайте видеото до края'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Маркирайте всички приложими:'
        } else if (min === max) {
          return `Изберете ${min !== 1 ? 'произволен' : 'само'} ${min} елемент${min !== 1 ? 'a' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Изберете поне ${min} елемент${min !== 1 ? 'а' : ''}, но не повече от ${max}:`
        } else if (5000 === max && min > 0) {
          return `Изберете поне ${min} елемент${min !== 1 ? 'а' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Изберете не повече от ${max} елемент${max !== 1 ? 'a' : ''}:`
        } else {
          return 'Маркирайте всички приложими:'
        }
      }
    },
    oe: {
      na: 'Не е приложимо',
      note: (min, max, optional) => {
        if (min === max) {
          return `Въведете ${1 !== min ? 'произволен' : 'точно'} ${min} символ${1 !== min ? 'a' : ''}${
            optional ? ' (по избор)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Въведете поне ${min} символ${1 !== min ? 'a' : ''} но не повече от ${max}${
            optional ? ' (по избор)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Въведете поне ${min} символ${1 !== min ? 'a' : ''}${optional ? ' (по избор)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Въведете не повече от ${max} символ${1 !== min ? 'a' : ''}${optional ? ' (по избор)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Попълнете следните полета:'
    },
    mx: {
      note: 'Преместете оцветените плъзгачи, за да продължите',
      dragSlider: 'Плъзнете наляво или надясно, за да отговорите'
    },
    psc: {
      dragLeftRight: 'Плъзнете наляво или надясно, за да отговорите'
    },
    ps: {
      note: (value, remaining) => `Разпределете ${remaining ? 'останалите' : ''} ${value} между елементите по-долу`,
      allDone: `Готово`,
      total: `Общо:`,
      dragSlider: 'Плъзнете наляво или надясно, за да отговорите'
    },
    cx: {
      note: 'Отворете полето и започнете да пишете отговора си, за да превъртите автоматично или да го изберете ръчно'
    },
    ro: {
      note: 'Плъзнете нагоре или надолу, за да пренаредите:'
    },
    md: {
      note1:
        'Кликнете/натиснете върху елемента по Вашия <b>първи избор</b>.<br/>Кликнете/натиснете отново, за да изчистите избора.',
      note2:
        'Сега кликнете/натиснете върху елемента по Вашия <b>последен избор</b>.<br/>Кликнете/натиснете отново, за да изчистите избора.',
      note3:
        'Благодаря! Продължете към следващия въпрос <br/ >или кликнете/натиснете върху всеки неизбран елемент, за да започнете отначало.'
    },
    aro: {
      note: 'Изберете по един елемент от всяка двойка:'
    },
    wd: {
      note: 'Уверете се, че всяка следваща стойност е по-голяма от предишната.'
    },
    emd: {
      note: 'Изгледайте видеото до края',
      noAnswers: 'Няма опция за отговор. Кликнете „Напред“, за да продължите.',
      start: 'Кликнете и задръжте за започване',
      resume: 'Кликнете и задръжте за продължаване',
      continue: 'Готови сте! <br />Кликнете <strong>Напред</strong> за да продължите',
      continueMobile: 'Готови сте! <br />Кликнете <strong>ТУК</strong> за да продължите',
      training: {
        session: 'Обучителна сесия',
        note: 'Завършете обучението',
        moveLeft: 'Плъзнете циферблата докрай <strong>наляво</strong>',
        moveBottom: 'Плъзнете циферблата докрай <strong>надолу</strong>',
        moveRight: 'Плъзнете циферблата докрай <strong>надясно</strong>',
        moveTop: 'Плъзнете циферблата докрай <strong>нагоре</strong>',
        success: 'Страхотно!'
      }
    },
    sft: {
      noAnswers: 'Няма опция за отговор. Кликнете „Напред“, за да продължите.',
      note: 'Отговорете възможно най-бързо с отговора, който интуитивно изглежда правилен',
      imageError: 'No image exposure time chosen',
      finish: 'Готови сте! <br /> Кликнете „Напред“, за да продължите',
      training: {
        start:
          '<p>Този въпрос ще Ви покаже бързо различни думи и ще изисква Вашата концентрация. ' +
          'Ще трябва да реагирате бързо, за да отговорите. </p> <p>Готови ли сте да се упражнявате?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Натиснете "{buttonLeft}"`
            : (mouse ? `Кликнете "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Натиснете клавиша "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Натиснете "{buttonRight}"`
            : (mouse ? `Кликнете "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Натиснете клавиша "{keyBtnRight}"` : ''),
        fail: () => 'Твърде бавно',
        success: () => 'Страхотно!',
        finish: () =>
          '<p><strong> Отлично!</strong></p><p>Уверете се, че няма <br />' +
          'да се разсейвате през<br/> следващите 2 – 3 минути</p><p>Кликнете „Напред“, за да започнете, когато сте готови.</p>'
      },
      buttons: {
        start: 'Започни',
        yesno: {
          left: 'Да',
          right: 'Не'
        },
        matches: {
          left: 'Съвпадение',
          right: 'Несъвпадение'
        },
        fits: {
          left: 'Подходящо',
          right: 'Неподходящо'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: 'Да',
          right: 'Не'
        },
        matchesRev: {
          left: 'Съвпадение',
          right: 'Несъвпадение'
        },
        fitsRev: {
          left: 'Подходящо',
          right: 'Неподходящо'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
